import React from "react";
import Select from "../../../../common/Select.jsx";
import { SOURCE_TYPE_MAP, SOURCE_PROPS } from "./source_const.jsx";
import MapboxHelpTooltip from "../component/MapboxHelpTooltip.jsx";
import AdvancedSetting from '../component/AdvancedSetting.jsx';

function SourceSetting({updateField, index, data}) {
    const {field_label, id, advancedSetting} = data;
    const type = data.type || 'geojson';
    return (
      <div className='w-100'>
        <label className='col-xs-12 col-md-12'>
          {SOURCE_PROPS.label.title}
          <MapboxHelpTooltip description={SOURCE_PROPS.label.description}/>
          <input
              type="text"
              className="form-control col-xs-10 col-md-10"
              name="field_label"
              data-index={index}
              value={field_label}
              onChange={(e) => updateField(`sourceFields.${index}.field_label`, e.target.value)}
          />
        </label>
        <label className='col-xs-12 col-md-12'>
          {SOURCE_PROPS.type.title}
          <MapboxHelpTooltip description={SOURCE_PROPS.type.description} />
          <Select
            value={type || SOURCE_PROPS.type.default}
            options={SOURCE_PROPS.type.options}
            onChange={(v) => updateField(`sourceFields.${index}.type`, v)}
          />
        </label>
        {SOURCE_TYPE_MAP[type](updateField, data, index)}
        <AdvancedSetting 
          update={(val) => updateField(`sourceFields.${index}.advancedSetting`, val)} 
          title={SOURCE_PROPS.advancedSetting.title}
          description={SOURCE_PROPS.advancedSetting.description}
          setting={advancedSetting}
        />
      </div>
    );
}

export default SourceSetting